import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/pages/Home';
import ToursPage from './components/pages/Tours';
import AboutPage from './components/pages/About';
import ContactPage from './components/pages/Contact';
import GardenRouteTourPage from './components/pages/GardenRouteTourPage';
import CityTourPage from './components/pages/CityTourPage';
import FullDaySafariPage from './components/pages/FullDaySafariPage';
import SharkCageDivingPage from './components/pages/SharkCageDiving';
import TableMountainPage from './components/pages/TableMountainPage';
import AquilaSafariPage from './components/pages/AquilaSafariPage';
import CapePeninsulaPage from './components/pages/CapePeninsulaPage';
import './App.css';
import CapeWinelandsPage from './components/pages/CapeWinelandsPage';
import TownshipTourPage from './components/pages/TownShipTourPage';
import OvernightSafariPage from './components/pages/OverNightSafariPage';
import MultiDaySafariPage from './components/pages/MultiDaySafariPage';
import ParaglidingPage from './components/pages/ParaglidingPage';
import ZipliningPage from './components/pages/ZipliningPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tours" element={<ToursPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/tours/garden-route" element={<GardenRouteTourPage />} />
            <Route path="/tours/city-tour" element={<CityTourPage />} />
            <Route path="/tours/full-day-safari" element={<FullDaySafariPage />} />
            <Route path="/tours/shark-cage-diving" element={<SharkCageDivingPage />} />
            <Route path="/tours/table-mountain" element={<TableMountainPage />} />
            <Route path="/tours/aquila-safari" element={<AquilaSafariPage />} />
            <Route path="/tours/cape-peninsula" element={<CapePeninsulaPage />} />
            <Route path="/tours/cape-winelands" element={<CapeWinelandsPage />} />
            <Route path="/tours/town-ship" element={<TownshipTourPage />} />
            <Route path="tours/overnight-safari" element={<OvernightSafariPage />} />
            <Route path="tours/multiday-safari" element={< MultiDaySafariPage />} />
            <Route path="tours/paragliding" element={< ParaglidingPage />} />
            <Route path="tours/ziplining" element={< ZipliningPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
